(ns app.front.view.conditions.list
  (:require [app.domain.application.condition.model :as condition-model]
            [app.domain.attachment.file-formats :as file-formats]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.placeholder-button :as ui-placeholder-button]
            [app.front.ui.section :as section]
            [app.front.util :as futil]
            [app.front.view.conditions.comments :as comments-list]
            [app.front.view.conditions.common :as condition-common]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [re-frame.std-interceptors :as interceptors]))


(rf/reg-event-db ::open-editor
  (fn [db _]
    (-> db
        (assoc-in [::application-conditions :editor-open?] true))))

(rf/reg-event-fx ::trigger-add-condition
  (fn [{:keys [db]} _]
    {:db (assoc-in db [::application-conditions :editor-open?] true)
     :fx [[:dispatch [::section/toggle-collapsed (section/get-section-id :application-conditions) false]]
          [::futil/scroll-to-section :application-conditions]]}))


(rf/reg-event-db ::close-editor
  (fn [db _]
    (-> db
        (p/dissoc-in [::application-conditions :editor-open?])
        (p/dissoc-in [::application-conditions :loading?])
        (p/dissoc-in [::application-conditions :edited-fields :new]))))


(rf/reg-sub ::loading?
  (fn [db _]
    (get-in db [::application-conditions :loading?] false)))


(rf/reg-event-db ::clear-loading
  (fn [db _]
    (p/dissoc-in db [::application-conditions :loading?])))


(rf/reg-event-db ::change-field
  (fn [db [_ id field value]]
    (assoc-in db [::application-conditions :edited-fields id field] value)))


(rf/reg-event-fx ::create-condition
  (fn [{:keys [db]} [_ application-id]]
    (let [condition (-> db ::application-conditions :edited-fields :new)]
      {:db       (assoc-in db [::application-conditions :loading?] true)
       :dispatch [::process/signal
                  application-id
                  [:process.signal/create-application-condition condition]
                  {:on-success [::close-editor]
                   :on-error   [::clear-loading]
                   :notify     {:success :changes-saved}}]})))


(rf/reg-event-fx ::save-condition
  (fn [{:keys [db]} [_ application-id condition-id]]
    (let [edited-fields (get-in db [::application-conditions :edited-fields condition-id])
          payload       (merge {:id condition-id} edited-fields)]
      {:db       (assoc-in db [::application-conditions :loading?] true)
       :dispatch [::process/signal
                  application-id
                  [:process.signal/edit-application-condition payload]
                  {:on-success [::close-edit-condition condition-id]
                   :on-error   [::clear-loading]
                   :notify     {:success :changes-saved}}]})))


(rf/reg-event-fx ::delete-condition
  (fn [{:keys [db]} [_ application-id condition-id]]
    {:db       (assoc-in db [::application-conditions :loading?] true)
     :dispatch [::process/signal
                application-id
                [:process.signal/delete-application-condition {:id condition-id}]
                {:on-success [::clear-loading]
                 :on-error   [::clear-loading]
                 :notify     {:success :condition/deleted}}]}))


(rf/reg-event-db ::edit-condition
  (fn [db [_ condition-id]]
    (update-in db [::application-conditions :editing-ids] #(conj (set %) condition-id))))


(rf/reg-event-db ::close-edit-condition
  (fn [db [_ condition-id]]
    (-> db
        (update-in [::application-conditions :editing-ids] #(disj % condition-id))
        (p/dissoc-in [::application-conditions :loading?]))))


(rf/reg-event-fx ::toggle-condition
  (fn [_ [_ application-id condition-id]]
    {:dispatch [::process/signal
                application-id
                [:process.signal/toggle-application-condition {:id condition-id}]]}))


(rf/reg-sub ::condition-attachments
  (fn [[_ condition-id]]
    (rf/subscribe [::entities/entities {:entity/parent condition-id
                                        :entity/type   :entity.type/file}]))
  (fn [files]
    (->> files
         (filter #(= :file.category/condition-attachment (:file/category %)))
         (sort-by :entity/created))))


(rf/reg-event-fx ::add-attachment
  (fn [_ [_ fsm-target-id condition-id file-id filename content-type md5]]
    {:dispatch [::process/signal
                fsm-target-id
                [:process.signal/add-condition-attachment {:id                condition-id
                                                           :file-id           file-id
                                                           :file/filename     filename
                                                           :file/content-type content-type
                                                           :file/md5          md5}]
                {:notify {:success :condition/attachment-added}}]}))


(rf/reg-event-fx ::edit-attachment-description
  (fn [_ [_ fsm-target-id condition-id file-id description]]
    {:dispatch [::process/signal
                fsm-target-id
                [:process.signal/edit-condition-attachment {:id               condition-id
                                                            :file-id          file-id
                                                            :file/description description}]
                {:on-success [::close-attachment-description-editor file-id]
                 :notify     {:success :condition/attachment-description-saved}}]}))


(rf/reg-event-db ::open-attachment-description-editor
  (fn [db [_ file-id description]]
    (assoc-in db [::application-conditions :attachment-descriptions file-id] (or description ""))))


(rf/reg-event-db ::change-attachment-description
  (fn [db [_ file-id description]]
    (assoc-in db [::application-conditions :attachment-descriptions file-id] description)))


(rf/reg-event-db ::close-attachment-description-editor
  (fn [db [_ file-id]]
    (p/dissoc-in db [::application-conditions :attachment-descriptions file-id])))


(rf/reg-sub ::attachment-description
  :<- [::application-conditions]
  (fn [state [_ file-id]]
    (get-in state [:attachment-descriptions file-id])))


(rf/reg-event-fx ::delete-attachment
  (fn [_ [_ fsm-target-id condition-id file-id]]
    {:dispatch [::process/signal
                fsm-target-id
                [:process.signal/delete-condition-attachment {:id      condition-id
                                                              :file-id file-id}]
                {:notify {:success :condition/attachment-removed}}]}))


(def insert-template (condition-common/insert-template-fn
                       :application.condition/title
                       :application.condition/body))

(rf/reg-sub ::application-conditions
  :-> ::application-conditions)

(rf/reg-event-db ::insert-template
  (fn [db [_ condition-id template]]
    (let [generation (inc (::insert-template-generation db 0))]
      (-> db
          (assoc ::insert-template-generation generation)
          (assoc :condition-edit-key (str condition-id "-" (:db/id template) "-" generation "-preview-key"))
          (update-in [::application-conditions :edited-fields condition-id] insert-template template)))))

(rf/reg-sub ::creating-new?
  :<- [::application-conditions]
  :-> :editor-open?)


(rf/reg-sub ::editing-ids
  :<- [::application-conditions]
  :-> :editing-ids)


(rf/reg-sub ::edited-fields
  :<- [::application-conditions]
  (fn [state [_ condition-id]]
    (get-in state [:edited-fields condition-id])))


(rf/reg-sub ::new-condition-fields
  :<- [::application-conditions]
  (fn [state _]
    (get-in state [:edited-fields :new] {})))

(rf/reg-sub ::required-fields-filled?
  (fn [[_ condition-id]]
    (rf/subscribe [::edited-fields condition-id]))
  (fn [edited-fields [_ id]]
    (and (or (number? id)
             ;; For a new condition every required key must be present
             (every? #(contains? edited-fields %) condition-model/condition-required-keys))
         (->> condition-model/condition-required-keys
              (select-keys edited-fields)
              (every? (fn [[_ value]]
                        (if (string? value)
                          (futil/not-blank? value)
                          (some? value))))))))


(rf/reg-sub ::can-save?
  (fn [[_ condition-id fsm-target-id save-signal]]
    [(rf/subscribe [::loading?])
     (rf/subscribe [::process/signal-permitted? fsm-target-id [save-signal]])
     (rf/subscribe [::required-fields-filled? condition-id])])
  (fn [[loading? save-permitted? filled?]]
    (and (not loading?) save-permitted? filled?)))


(rf/reg-sub ::can-delete?
  (fn [[_ fsm-target-id delete-signal]]
    [(rf/subscribe [::loading?])
     (rf/subscribe [::process/signal-permitted? fsm-target-id [delete-signal]])])
  (fn [[loading? delete-permitted?]]
    (and (not loading?) delete-permitted?)))

(rf/reg-event-db ::toggle-reodering?
  (interceptors/path ::application-conditions)
  (fn [state _]
    (update state :reordering-conditions? not)))

(rf/reg-sub ::reordering-conditions?
  :<- [::application-conditions]
  :-> :reordering-conditions?)


(defn condition-editor [{:keys [id fsm-target-id fields edited-fields default-group-id
                                tr save-evt cancel-evt save-tr-key]}]
  (let [loading?      (<sub [::loading?])
        creating-new? (= id :new)
        save-signal   (if creating-new?
                        :process.signal/create-application-condition
                        :process.signal/edit-application-condition)]
    [condition-common/condition-editor-view
     (util/mmap {:can-save?           (<sub [::can-save? id fsm-target-id save-signal])
                 :can-delete?         (<sub [::can-delete? fsm-target-id :process.signal/delete-application-condition])
                 :get-field           (fn [_id field] (if (contains? edited-fields field)
                                                        (get edited-fields field)
                                                        (get fields field)))
                 :set-field           (fn [id field val] (rf/dispatch-sync [::change-field id field val]))
                 :on-save             #(>evt save-evt)
                 :on-cancel           #(>evt cancel-evt)
                 :on-delete           #(>evt [::delete-condition fsm-target-id id])
                 :templates           (<sub [::condition-common/templates-for-group default-group-id])
                 :insert-template     (fn [id template] (>evt [::insert-template id template]))
                 :condition-instance? true
                 :show-attachment-required?
                 (<sub [::process/signal-permitted? fsm-target-id [:process.signal/add-condition-attachment]])}
                id tr default-group-id save-tr-key loading? creating-new?)]))


(defn new-condition [fsm-target-id default-group-id tr]
  (let [open?         (<sub [::creating-new?])
        new-condition (<sub [::new-condition-fields])]
    (if open?
      [condition-editor {:id               :new
                         :fsm-target-id    fsm-target-id
                         :fields           new-condition
                         :tr               tr
                         :default-group-id default-group-id
                         :save-evt         [::create-condition fsm-target-id]
                         :cancel-evt       [::close-editor]
                         :save-tr-key      :condition/add}]
      [:div.mb-4 (cc/button {:size     :small
                             :on-click #(>evt [::open-editor default-group-id])}
                            (tr [:condition/add]))])))


(defn- attachment-description [tr fsm-target-id condition-id can-edit? {:file/keys [description] :as file}]
  (let [file-id (:db/id file)
        value   (<sub [::attachment-description file-id])
        saving? (<sub [::process/signal-processing? :process.signal/edit-condition-attachment])]
    (if (some? value)
      [:div.flex.items-end.gap-2
       [ui/text-input {:id          (str "condition-attachment-description-" file-id)
                       :label-text  (tr [:condition/attachment-description])
                       :placeholder (tr [:condition/attachment-description])
                       :hide-label  true
                       :light       true
                       :auto-focus  true
                       :class       "w-72"
                       :disabled    saving?
                       :value       value
                       :on-change   #(rf/dispatch-sync [::change-attachment-description file-id (futil/tval %)])}]
       (cc/button {:kind     :ghost
                   :size     :field
                   :disabled saving?
                   :on-click #(>evt [::close-attachment-description-editor file-id])}
                  (tr [:cancel]))
       (cc/button {:kind     :primary
                   :size     :field
                   :disabled (or saving? (= (or description "") value))
                   :on-click #(>evt [::edit-attachment-description fsm-target-id condition-id file-id value])}
                  (tr [:save]))]
      [:<>
       (when (not-empty description)
         [:span.text-sm.text-gray-700 description])
       (when can-edit?
         (cc/button {:icon     i/pen
                     :kind     :ghost
                     :size     :small
                     :on-click #(>evt [::open-attachment-description-editor file-id description])}
                    (tr [:edit])))])))


(defn- attachment-row [tr fsm-target-id condition-id can-edit? can-delete? file]
  [:li.flex.items-center.gap-2.mb-1
   [file-download/download-workspace-file-link file {:class "break-words"}]
   [attachment-description tr fsm-target-id condition-id can-edit? file]
   (when can-delete?
     [ui/modal-confirmation-button
      {:tr                  tr
       :id                  (str "delete-condition-attachment-" (:db/id file))
       :modal-class         "text-left"
       :modal-title         (tr [:condition/delete-attachment])
       :trigger-button-opts {:icon i/trash
                             :kind :ghost
                             :size :small}
       :trigger-button-text (tr [:delete])
       :no-button-text      (tr [:cancel])
       :yes-button-text     (tr [:delete])
       :on-yes-click        #(>evt [::delete-attachment fsm-target-id condition-id (:db/id file)])}
      [:p (tr [:condition/delete-attachment-body])]])])


(defn attachments-section [tr fsm-target-id condition-id]
  (let [files       (<sub [::condition-attachments condition-id])
        can-add?    (<sub [::process/signal-permitted? fsm-target-id [:process.signal/add-condition-attachment]])
        can-edit?   (<sub [::process/signal-permitted? fsm-target-id [:process.signal/edit-condition-attachment {:id condition-id}]])
        can-delete? (<sub [::process/signal-permitted? fsm-target-id [:process.signal/delete-condition-attachment {:id condition-id}]])]
    (when (or can-add? (seq files))
      [:div.col-span-3.md:col-span-6.max-w-screen-md
       {:on-click #(.stopPropagation %)}
       [:div.font-bold.mb-2 (tr [:condition/attachments])]
       (if (seq files)
         [:ul.mb-2
          (futil/for-frag [file files]
            ^{:key (:db/id file)}
            [attachment-row tr fsm-target-id condition-id can-edit? can-delete? file])]
         [:div.mb-2.text-sm (tr [:condition/no-attachments])])
       (when can-add?
         [upload/upload-button
          (str "condition-attachment-" condition-id)
          {:attach-file-fn  (fn [file-id filename content-type md5]
                              (>evt [::add-attachment fsm-target-id condition-id
                                     file-id filename content-type md5]))
           :button-i18n-key :condition/add-attachment
           :accept-types    file-formats/condition-attachment-accept-value-for-input}])])))


(defn condition-row [condition index fsm-target-id edit-view? tr reordering? &
                     [{:keys [augment-target-props augment-draggable-props]}]]
  (let [published-or-overdue? ((du/in-state-fn :application.condition.state/published
                                               :application.condition.state/overdue)
                               condition)
        state                 (condition-model/condition->state condition)
        pre-consultation?     (condition-model/pre-consultation-origin? condition)
        signal-allowed?       #(and edit-view?
                                    (<sub [::process/signal-permitted?
                                           fsm-target-id
                                           [%]]))]
    [condition-common/condition-row
     (util/mmap {:item                condition
                 :id                  (:db/id condition)
                 :border-color        (-> state condition-common/state->border)
                 :item->title         :application.condition/title
                 :item->body          :application.condition/body
                 :item->due-date      :application.condition/due-date
                 :item->state         (constantly state)
                 :item->group-name    (comp :group/name :application.condition/addressed-to)
                 :pre-consultation?   pre-consultation?
                 :item->approval      (fn [condition]
                                        (when-let [approval-condition (condition-model/latest-approval-condition-with-result condition)]
                                          {:result (:approval-condition/result approval-condition)
                                           :user   (or (some-> approval-condition :entity/parent :approval/completed-by user-model/full-name)
                                                       (-> approval-condition :entity/parent :latest-change :user))
                                           :ts     (-> approval-condition :entity/parent :approval/completed)}))
                 :item-closed?        (some? (:application.condition/closed condition))
                 :item->closed-date   (comp (<sub [::date-util/date-fn]) :application.condition/closed)
                 :item->closed-by     (comp user-model/full-name :application.condition/closed-by)
                 :can-edit?           (signal-allowed? :process.signal/edit-application-condition)
                 :can-close?          (and published-or-overdue?
                                           (signal-allowed? :process.signal/toggle-application-condition))
                 :on-edit             (fn [id] (>evt [::edit-condition id]))
                 :on-close            (fn [id] (>evt [::toggle-condition fsm-target-id id]))
                 :attachment-required-but-missing?
                 (condition-model/attachment-required-but-missing? condition)
                 :attachments-section (when edit-view?
                                        [attachments-section tr fsm-target-id (:db/id condition)])}
                tr index reordering? augment-target-props augment-draggable-props)]))


(defn conditions-list [{:keys [tr fsm-target-id default-group-id editing-ids conditions can-create? reordering? title-key]
                        :or   {title-key :view/application-conditions}}]
  [:div.mb-12
   [condition-common/header-row (util/mmap {:title     (tr [title-key])
                                            :row-count (count conditions)})]
   (if (seq conditions)
     [dnd/wrap-dnd
      {:id               (str "application-conditions-dnd-" fsm-target-id "-" (name title-key))
       :items            conditions
       :props-for-source {:class "translate-x-2"}
       :on-reorder       (fn [from to]
                           (>evt [::process/signal
                                  fsm-target-id
                                  [:process.signal/reorder-application-conditions
                                   {:conditions (dnd/ordering-tx-for-entity from to)}]]))}
      (fn [{:keys [sorted] :as draggable-props}]
        (futil/for-frag [{:keys [db/id ordered/order] :as condition} sorted]
          (if (contains? editing-ids id)
            ^{:key id}
            [condition-editor {:id               id
                               :fsm-target-id    fsm-target-id
                               :edited-fields    (<sub [::edited-fields id])
                               :fields           condition
                               :tr               tr
                               :default-group-id default-group-id
                               :save-evt         [::save-condition fsm-target-id id]
                               :cancel-evt       [::close-edit-condition id]
                               :save-tr-key      :condition/save}]
            ^{:key id}
            [condition-row condition order fsm-target-id true tr reordering? draggable-props])))]
     [:div.mb-4 (tr [:condition/none-defined])])

   (when (and can-create?
              (not reordering?))
     [new-condition fsm-target-id default-group-id tr])])

(defn- reorder-button [tr reordering? on-click]
  {:kind        :tertiary
   :icon        (if reordering? i/remove i/arrows-up-down)
   :on-click    on-click
   :description (tr [(if reordering? :done :checklist.topic/reorder)])})

(defn- conditions-and-comments-v2 [{:keys [fsm-target workspace tr help? comments? conditions-subsection? title-key]
                                    :or   {help? true comments? true conditions-subsection? true}}]
  (let [fsm-target-id           (:db/id fsm-target)
        application?            (= :entity.type/application (:entity/type fsm-target))
        conditions              (<sub [::condition-common/permit-specific-conditions fsm-target-id])
        topics                  (<sub [::comments-list/topics fsm-target])
        can-create?             (<sub [::process/signal-permitted?
                                       fsm-target-id
                                       [:process.signal/create-application-condition]])
        can-reorder-topics?     (and (<sub [::process/signal-permitted?
                                            fsm-target-id
                                            [:process.signal/reorder-checklist-topics]])
                                     (next topics))
        can-reorder-conditions? (and (<sub [::process/signal-permitted?
                                            fsm-target-id
                                            [:process.signal/reorder-application-conditions]])
                                     (next conditions))
        can-create-topic?       (<sub [::process/signal-permitted?
                                       fsm-target-id
                                       [:process.signal/create-checklist-topic]])
        editing-ids             (<sub [::editing-ids])
        auth-group              (:domain/authority-group workspace)
        default-group-id        (:db/id auth-group)
        topics-count            (count topics)
        reordering-conditions?  (<sub [::reordering-conditions?])
        reordering-topics?      (<sub [::comments-list/reordering-topics?])]
    [:div.mb-8
     (when help?
       [:div.mb-4
        [ui/help-2 (tr [:checklist/section-help])]])

     (let [conditions-list-view [conditions-list
                                 (merge (util/mmap tr default-group-id editing-ids fsm-target-id conditions can-create?)
                                        {:reordering? (and reordering-conditions? can-reorder-conditions?)
                                         :title-key   (or title-key
                                                          (if application?
                                                            :view/application-conditions
                                                            :condition/conditions))})]]
       (if conditions-subsection?
         [section/subsection-3
          {:title          (tr [:condition/conditions])
           :header-buttons [(when can-reorder-conditions?
                              (reorder-button tr
                                              reordering-conditions?
                                              #(>evt [::toggle-reodering?])))]}
          conditions-list-view]
         conditions-list-view))


     (when (and comments?
                (or can-create-topic? (seq topics)))
       [section/subsection-3
        {:title          (tr [:checklist.comment/comments])
         :header-extra   (cc/checkbox {:id         "show-cleared-comments-checkbox"
                                       :label-text (tr [:checklist.comment/show-cleared])
                                       :checked    (true? (<sub [::comments-list/show-cleared-comments?]))
                                       :on-change  #(>evt [::comments-list/set-cleared-comments %])})
         :header-buttons [(when can-reorder-topics?
                            (reorder-button tr
                                            reordering-topics?
                                            #(>evt [::comments-list/toggle-reordering])))]}
        (when (seq topics)
          [comments-list/topics-list (util/mmap {:reordering? (and reordering-topics? can-reorder-topics?)}
                                                tr fsm-target topics fsm-target-id)])

        [comments-list/new-topic fsm-target tr]
        (when (and can-create-topic? (not reordering-topics?) (not (<sub [::comments-list/creating-new-topic?])))
          [:div.mt-6
           [ui-placeholder-button/placeholder-button
            {:icon     i/plus
             :on-click #(>evt [::comments-list/open-topic-editor (if (= topics-count 0) 1 (inc topics-count))])
             :title    (tr [:checklist.topic/add-long])}]])])]))


(defn conditions-and-comments-section
  ([state fsm-target]
   (conditions-and-comments-section state fsm-target {}))
  ([{:keys [workspace tr] :as state} fsm-target {:keys [section-title-key show-when-can-create? show-when-creating?]
                                                 :or   {show-when-can-create? true}
                                                 :as   opts}]
   (let [fsm-target-id              (:db/id fsm-target)
         conditions                 (<sub [::condition-common/permit-specific-conditions fsm-target-id])
         topics                     (<sub [::comments-list/topics fsm-target])
         show-section-to-applicant? (or (seq conditions)
                                        (seq topics))
         creating-new?              (<sub [::creating-new?])
         can-create?                (<sub [::process/signal-permitted?
                                           fsm-target-id
                                           [:process.signal/create-application-condition]])]
     (when (or show-section-to-applicant?
               (and show-when-can-create? can-create?)
               (and show-when-creating? creating-new?))
       [section/initially-collapsed-section
        :application-conditions
        state
        (or section-title-key :view/application-conditions-and-comments)
        [conditions-and-comments-v2 (merge (util/mmap fsm-target workspace tr) opts)]]))))
